import React, {useEffect, useState} from 'react'

// Components
import Loader from '../Loader';
import DataTableRows from './DataTableRows'
import DataTableHeader from './DataTableHeader';

// CSS
import "../../../css/data_table.css";
import useLoadData from './useLoadData';

const DataTable = ({
    columns,
    editRoute,
    apiEndpoint,
    defaultColumnSort
}) => {
    // Loads table data from api given the endpoint
    const [isLoading, error, data] = useLoadData(apiEndpoint);

    const [searchData, setSearchData] = useState([]); // The filtered out data used for searches.
    const [searchQuery, setSearchQuery] = useState('');
    const [searchColumn, setSearchColumn] = useState('name');  // The column to search

    // This will track the column that is currently being sorted and if it's either ASC or DESC (true/false)
    const [columnSort, setColumnSort] = useState({
        sortKey: !!defaultColumnSort ? defaultColumnSort : '',
        asc: false
    })
    
    // Filter search data when a search query is typed
    useEffect(() => {
        if(searchQuery === ''){
            // setSearchData([]);
        } else {
            setSearchData([...data.filter((item) => !!item[searchColumn] && item[searchColumn].toLowerCase().includes(searchQuery.toLowerCase()))])
        }
    }, [searchQuery, searchColumn])

    // This will sort the column to ascending by default.
    // If we are sorting the same column (same key), instead sort by desc
    const sortColumn = (columnKey) => {
        setColumnSort(prevSort => ({
            ...prevSort,
            sortKey: columnKey,
            asc: columnKey === prevSort.sortKey ? !prevSort.asc : true
        }))
    }

    return (
        error !== '' ? <span>Error: {error}</span> :
        isLoading ? <Loader /> : (
            <React.Fragment>
                <div className="padded-listing">
                    <div className='dt-search-label'>Search by column</div>
                    <div className="input-wrapper dt-searchbar">
                        <select className="dt-search-select" name="searchColumn" value={searchColumn} id="searchColumn" onChange={(e) => setSearchColumn(e.target.value)}>
                            <option value="name">Name</option>
                            <option value="email">Email</option>
                        </select>
                        <input
                            type="text"
                            name="search"
                            placeholder={`Search ${searchColumn}`}
                            value={searchQuery}
                            onChange={e => setSearchQuery(e.target.value)}
                            autoFocus
                        />
                    </div>
                </div>
                <table className="display_table data_table">
                    <thead>
                        <DataTableHeader 
                            columns={columns} 
                            columnSort={columnSort} 
                            onColumnClick={(key) => sortColumn(key)}
                        />
                    </thead>
                    <tbody>
                        {(searchData.length === 0 && searchQuery === '' && !!data) 
                            ? data.length === 0 
                                ? <tr><td className="dt-no-results" colSpan={columns.length}>No results found.</td></tr> 
                                : <DataTableRows 
                                    data={data}
                                    colSortKey={columnSort.sortKey}
                                    colSortAsc={columnSort.asc}
                                    colData={columns} 
                                    editRoute={editRoute}
                                />
                            : searchData.length === 0 
                                ? <tr><td className="dt-no-results" colSpan={columns.length}>No results found.</td></tr> 
                                : <DataTableRows 
                                    data={searchData}
                                    colSortKey={columnSort.sortKey}
                                    colSortAsc={columnSort.asc}
                                    colData={columns} 
                                    editRoute={editRoute}
                                />
                        }
                    </tbody>
                </table>
            </React.Fragment>
        )
    )
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/utils/DataTable/DataTable.js